import { Typography } from "@mui/material";
import { type FC } from "react";

import { RichTooltip } from "~/components/UI/RichTooltip";
import type { IOutcomeConsensus } from "~/types/event";
import { chanceColumn } from "~/utils/marketValue";

import * as Styles from "../styles";
import { getChanceBreakdown } from "./getChanceBreakdown";

const tooltipTitle = "PH Consensus Breakdown";
const tooltipActionText = "Learn more about our methodology";

interface IChanceGroupedCellProps {
  outcome: IOutcomeConsensus | null;
}

export const ChanceGroupedCell: FC<IChanceGroupedCellProps> = ({ outcome }) => (
  <Typography
    variant="caption"
    sx={{
      fontWeight: 700,
      position: "relative",
      padding: "0 0.8rem",
    }}
  >
    <RichTooltip
      textTitle={tooltipTitle}
      title={getChanceBreakdown(outcome)}
      actionText={tooltipActionText}
    >
      <Styles.Icon
        color="disabled"
        fontSize="small"
        sx={{ fontSize: "14px" }}
      />
    </RichTooltip>
    {chanceColumn.format(outcome?.chance ?? null)}
  </Typography>
);
